import React, { FC } from 'react';

import BlankCard from '../BlankCard';

import * as Styles from './_tabDisplay.module.scss';

export type TTabs = {
    name: string;
    element: JSX.Element;
};

type TTabDisplayProps = {
    containerStyle?: string;
    currentTab: string;
    tabs: TTabs[];
}

const TabDisplay: FC<TTabDisplayProps> = ({
    containerStyle,
    currentTab,
    tabs,
}) => {
    const content = tabs.find(tab => tab.name === currentTab)?.element;

    if (!content) return null;

    return (
        <BlankCard containerStyle={`${Styles.container}${containerStyle ? ` ${containerStyle}` : ''}`}>
            {content}
        </BlankCard>
    );
};

export default TabDisplay;
